exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-FieldLabel-label{margin-left:10px;color:#929292;text-align:initial;width:100%}.src-components-shared-FieldLabel-green{color:#0b9444}", ""]);

// exports
exports.locals = {
	"label": "src-components-shared-FieldLabel-label",
	"green": "src-components-shared-FieldLabel-green"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/FieldLabel/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/FieldLabel/styles.scss
// module chunks = 1